import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { fetchShipFromOrders, fetchSalesOrderDetail } from '../../actions/shipFromOrders_actions';

import ShipFromOrders from '../../components/Sales/shipFromOrders';

const shipFromOrders = reduxForm({
  form: 'shipFromOrders',
  destroyOnUnmount: false,
})(ShipFromOrders);

function mapStateToProps(state) {
  return {
    currentSalesOrder: state.shipFromOrders.currentSalesOrder,
    shipFromOrders: state.shipFromOrders.all,
    isLoading: state.shipFromOrders.isLoading,
    error: state.shipFromOrders.error,
    salesOrderDetail: state.shipFromOrders.currentSalesOrderDetail,
    salesOrderIsLoading: state.shipFromOrders.detailIsLoading,
    salesOrderError: state.shipFromOrders.detailError,
    salesOrdersFilter: state.shipFromOrders.salesOrdersFilter,
    userPermissions: state.auth.userPermissions,
    users: state.settings.all,
    usersIsLoading: state.settings.isLoading,
    usersError: state.settings.error,
    msoTotalPages: state.shipFromOrders.msoTotalPages,

    requestingShippingList: state.shipFromOrders.requestingShippingList,
    shippingListPDF: state.shipFromOrders.shippingListPDF,

    requestingPickingList: state.shipFromOrders.requestingPickingList,
    pickingListPDF: state.shipFromOrders.pickingListPDF,

    requestingPackingList: state.shipFromOrders.requestingPackingList,
    packingListPDF: state.shipFromOrders.packingListPDF,

    requestingSalesOrderPDF: state.shipFromOrders.requestingSalesOrderPDF,
    salesOrderPDF: state.shipFromOrders.salesOrderPDF,

    requestingBolIdPDF: state.shipFromOrders.requestingBolIdPDF,
    bolIdPDF: state.shipFromOrders.bolIdPDF,
    requestingBolWithoutLogPDF: state.shipFromOrders.requestingBolWithoutLogPDF,
    bolWithoutLogPDF: state.shipFromOrders.bolWithoutLogPDF,
    requestingBolLabel: state.shipFromOrders.requestingBolLabel,
    bolLabel: state.shipFromOrders.bolLabel,
    requestingBolFbaPDF: state.shipFromOrders.requestingBolFbaPDF,
    bolFbaPDF: state.shipFromOrders.bolFbaPDF,
    bolAddress: state.shipFromOrders.bolAddress,
    quoteLoading: state.shipFromOrders.quoteLoading,
  };
}

export default connect(mapStateToProps, {
  fetchShipFromOrders,
  fetchSalesOrderDetail,
})(shipFromOrders);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/shipFromOrders.jsx